module.exports = __webpack_public_path__ + "static/media/file.431a529d.svg";